/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ActivityCategoryDto } from '../models';
// @ts-ignore
import type { ActivityEntryDto } from '../models';
// @ts-ignore
import type { ProcessActivityPageableResponseDto } from '../models';
/**
 * RestProcessActivityApi - axios parameter creator
 */
export const RestProcessActivityApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Slad zmian na procesie i na ofertach: kto, kiedy i co zmienil. Najnowsze pierwsze.  Drobne zmiany tego samego typu, tego samego uzytkownika, wykonane w krotkim odstepie, sa zlozone w jeden wpis (`count` > 1). Pojedyncze skladowe takiego wpisu zwraca `/activity/{groupKey}`.  Bez `processOfferId` zwraca komplet: proces i wszystkie jego oferty. Z `processOfferId` zaweza do jednej oferty. 
         * @summary Log aktywnosci procesu i jego ofert
         * @param {string} processId 
         * @param {number} page 
         * @param {number} pageSize 
         * @param {string} [processOfferId] 
         * @param {Array<ActivityCategoryDto>} [categories] Filtr kategorii. Pusty &#x3D; wszystkie.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessActivity: async (processId: string, page: number, pageSize: number, processOfferId?: string, categories?: Array<ActivityCategoryDto>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('getProcessActivity', 'processId', processId)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getProcessActivity', 'page', page)
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('getProcessActivity', 'pageSize', pageSize)
            const localVarPath = `/api/processes/{processId}/activity`
                .replace('{processId}', encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (processOfferId !== undefined) {
                localVarQueryParameter['processOfferId'] = processOfferId;
            }

            if (categories) {
                localVarQueryParameter['categories'] = categories.join(COLLECTION_FORMATS.csv);
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Rozwiniecie wpisu zbiorczego z listy aktywnosci — wszystkie zmiany, ktore sie na niego zlozyly, najnowsze pierwsze. 
         * @summary Pojedyncze zmiany zlozone w jeden wpis logu
         * @param {string} processId 
         * @param {string} groupKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessActivityGroup: async (processId: string, groupKey: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('getProcessActivityGroup', 'processId', processId)
            // verify required parameter 'groupKey' is not null or undefined
            assertParamExists('getProcessActivityGroup', 'groupKey', groupKey)
            const localVarPath = `/api/processes/{processId}/activity/{groupKey}`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{groupKey}', encodeURIComponent(String(groupKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestProcessActivityApi - functional programming interface
 */
export const RestProcessActivityApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestProcessActivityApiAxiosParamCreator(configuration)
    return {
        /**
         * Slad zmian na procesie i na ofertach: kto, kiedy i co zmienil. Najnowsze pierwsze.  Drobne zmiany tego samego typu, tego samego uzytkownika, wykonane w krotkim odstepie, sa zlozone w jeden wpis (`count` > 1). Pojedyncze skladowe takiego wpisu zwraca `/activity/{groupKey}`.  Bez `processOfferId` zwraca komplet: proces i wszystkie jego oferty. Z `processOfferId` zaweza do jednej oferty. 
         * @summary Log aktywnosci procesu i jego ofert
         * @param {string} processId 
         * @param {number} page 
         * @param {number} pageSize 
         * @param {string} [processOfferId] 
         * @param {Array<ActivityCategoryDto>} [categories] Filtr kategorii. Pusty &#x3D; wszystkie.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProcessActivity(processId: string, page: number, pageSize: number, processOfferId?: string, categories?: Array<ActivityCategoryDto>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcessActivityPageableResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProcessActivity(processId, page, pageSize, processOfferId, categories, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessActivityApi.getProcessActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Rozwiniecie wpisu zbiorczego z listy aktywnosci — wszystkie zmiany, ktore sie na niego zlozyly, najnowsze pierwsze. 
         * @summary Pojedyncze zmiany zlozone w jeden wpis logu
         * @param {string} processId 
         * @param {string} groupKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProcessActivityGroup(processId: string, groupKey: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ActivityEntryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProcessActivityGroup(processId, groupKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessActivityApi.getProcessActivityGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestProcessActivityApi - factory interface
 */
export const RestProcessActivityApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestProcessActivityApiFp(configuration)
    return {
        /**
         * Slad zmian na procesie i na ofertach: kto, kiedy i co zmienil. Najnowsze pierwsze.  Drobne zmiany tego samego typu, tego samego uzytkownika, wykonane w krotkim odstepie, sa zlozone w jeden wpis (`count` > 1). Pojedyncze skladowe takiego wpisu zwraca `/activity/{groupKey}`.  Bez `processOfferId` zwraca komplet: proces i wszystkie jego oferty. Z `processOfferId` zaweza do jednej oferty. 
         * @summary Log aktywnosci procesu i jego ofert
         * @param {string} processId 
         * @param {number} page 
         * @param {number} pageSize 
         * @param {string} [processOfferId] 
         * @param {Array<ActivityCategoryDto>} [categories] Filtr kategorii. Pusty &#x3D; wszystkie.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessActivity(processId: string, page: number, pageSize: number, processOfferId?: string, categories?: Array<ActivityCategoryDto>, options?: RawAxiosRequestConfig): AxiosPromise<ProcessActivityPageableResponseDto> {
            return localVarFp.getProcessActivity(processId, page, pageSize, processOfferId, categories, options).then((request) => request(axios, basePath));
        },
        /**
         * Rozwiniecie wpisu zbiorczego z listy aktywnosci — wszystkie zmiany, ktore sie na niego zlozyly, najnowsze pierwsze. 
         * @summary Pojedyncze zmiany zlozone w jeden wpis logu
         * @param {string} processId 
         * @param {string} groupKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessActivityGroup(processId: string, groupKey: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ActivityEntryDto>> {
            return localVarFp.getProcessActivityGroup(processId, groupKey, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestProcessActivityApi - interface
 */
export interface RestProcessActivityApiInterface {
    /**
     * Slad zmian na procesie i na ofertach: kto, kiedy i co zmienil. Najnowsze pierwsze.  Drobne zmiany tego samego typu, tego samego uzytkownika, wykonane w krotkim odstepie, sa zlozone w jeden wpis (`count` > 1). Pojedyncze skladowe takiego wpisu zwraca `/activity/{groupKey}`.  Bez `processOfferId` zwraca komplet: proces i wszystkie jego oferty. Z `processOfferId` zaweza do jednej oferty. 
     * @summary Log aktywnosci procesu i jego ofert
     * @param {string} processId 
     * @param {number} page 
     * @param {number} pageSize 
     * @param {string} [processOfferId] 
     * @param {Array<ActivityCategoryDto>} [categories] Filtr kategorii. Pusty &#x3D; wszystkie.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcessActivity(processId: string, page: number, pageSize: number, processOfferId?: string, categories?: Array<ActivityCategoryDto>, options?: RawAxiosRequestConfig): AxiosPromise<ProcessActivityPageableResponseDto>;

    /**
     * Rozwiniecie wpisu zbiorczego z listy aktywnosci — wszystkie zmiany, ktore sie na niego zlozyly, najnowsze pierwsze. 
     * @summary Pojedyncze zmiany zlozone w jeden wpis logu
     * @param {string} processId 
     * @param {string} groupKey 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcessActivityGroup(processId: string, groupKey: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ActivityEntryDto>>;

}

/**
 * RestProcessActivityApi - object-oriented interface
 */
export class RestProcessActivityApi extends BaseAPI implements RestProcessActivityApiInterface {
    /**
     * Slad zmian na procesie i na ofertach: kto, kiedy i co zmienil. Najnowsze pierwsze.  Drobne zmiany tego samego typu, tego samego uzytkownika, wykonane w krotkim odstepie, sa zlozone w jeden wpis (`count` > 1). Pojedyncze skladowe takiego wpisu zwraca `/activity/{groupKey}`.  Bez `processOfferId` zwraca komplet: proces i wszystkie jego oferty. Z `processOfferId` zaweza do jednej oferty. 
     * @summary Log aktywnosci procesu i jego ofert
     * @param {string} processId 
     * @param {number} page 
     * @param {number} pageSize 
     * @param {string} [processOfferId] 
     * @param {Array<ActivityCategoryDto>} [categories] Filtr kategorii. Pusty &#x3D; wszystkie.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProcessActivity(processId: string, page: number, pageSize: number, processOfferId?: string, categories?: Array<ActivityCategoryDto>, options?: RawAxiosRequestConfig) {
        return RestProcessActivityApiFp(this.configuration).getProcessActivity(processId, page, pageSize, processOfferId, categories, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Rozwiniecie wpisu zbiorczego z listy aktywnosci — wszystkie zmiany, ktore sie na niego zlozyly, najnowsze pierwsze. 
     * @summary Pojedyncze zmiany zlozone w jeden wpis logu
     * @param {string} processId 
     * @param {string} groupKey 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProcessActivityGroup(processId: string, groupKey: string, options?: RawAxiosRequestConfig) {
        return RestProcessActivityApiFp(this.configuration).getProcessActivityGroup(processId, groupKey, options).then((request) => request(this.axios, this.basePath));
    }
}

